import * as yup from 'yup'
import {
    isNumber,
    requiredId,
    requiredString,
} from '../../../../../../../utils/validation'

const coursePriceValidationSchema = ({ formatMessage }) =>
    yup.object().shape({
        titleKz: requiredString({ formatMessage }),
        titleRu: requiredString({ formatMessage }),
        sloganKz: requiredString({ formatMessage }),
        sloganRu: requiredString({ formatMessage }),
        courseId: requiredId({ formatMessage }),
        duration: isNumber({ formatMessage }),
        optimalPrice: isNumber({ formatMessage }),
        requiredSubjectCount: isNumber({ formatMessage }),
        notRequiredSubjectCount: isNumber({ formatMessage }),
    })

const courseSubjectsPricesValidationSchema = ({ formatMessage }) =>
    yup.object().shape({
        courseSubjectsPrice: yup
            .array()
            .required(
                formatMessage({
                    id: 'isRequired',
                }),
            )
            .min(
                1,
                formatMessage(
                    {
                        id: 'mustAddQuestions',
                    },
                    { value: 1 },
                ),
            ),
    })

export default [
    coursePriceValidationSchema,
    courseSubjectsPricesValidationSchema,
]
